var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',_vm._l((_vm.comments),function(comment,index){return _c('b-list-group-item',{key:index},[_vm._v(_vm._s(comment))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }